import { createSlice } from '@reduxjs/toolkit'


const initialState = {
  SelectedEmp: [],
}

export const detailsReducer = createSlice({
  name: 'detailsReducer',
  initialState,
  reducers: {

    setDetailsSelectedEmp: (state, action) => {
      state.SelectedEmp = action.payload
    },

  },
})

export const { setDetailsSelectedEmp } = detailsReducer.actions

export default detailsReducer.reducer
